module.exports = __webpack_public_path__ + "static/media/6_School of the animals_CN.5ddb9c54.txt";